export default __webpack_public_path__ + "static/rec-2012-ii-997ee2b7c9b515e2b161bae940bbdeb5.png";